// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = ({
  pageHeader: { color: headerColor },
  palette: { grey, text },
  spacing: { unit }
}) => ({
  addWidgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& input[data-qa="addWidget-select-field"]': {
      height: 30,
      borderRadius: 30,
      fontSize: `${unit * 1.5}px`,
      paddingRight: 35,
      paddingLeft: 6,
      borderColor: headerColor || text.light,
      '& ::placeholder': {
        textAlign: 'center'
      }
    },
    '& div[data-qa="dropdown-panel"]': {
      borderBottomRightRadius: 5,
      borderBottomLeftRadius: 5,
      '& [class^="linkTitle"]': {
        color: grey.A700
      }
    },
    '& input[class*="disabled"]': {
      '& [class^="icon-caret-down"]': {
        fill: '#B8CFE7'
      }
    },
    '& .icon-caret-down': {
      top: unit
    },
    '& [class^="inputWrap"]': {
      width: 200,
      '& input::placeholder': {
        fontSize: `${unit * 1.5}px`
      },
      '& input:disabled': {
        '&::placeholder': {
          color: '#B8CFE7'
        }
      },
      '& button[class^="input"]': {
        borderRadius: 'inherit'
      }
    }
  },
  helpText: {
    fontSize: 11,
    marginTop: 8,
    color: '#a1c2e1'
  }
});

export default createUseStyles(styles);
